module.exports = __webpack_public_path__ + "img/issue_2.260786a6.png";